import { action } from 'satcheljs';

const removeSearchTableFromStore = action('removeSearchTableFromStore', (tableViewId: string) => ({
    tableViewId,
}));

export default removeSearchTableFromStore;
